import React, { useMemo } from 'react';
import { Checkbox, InputNumber } from 'antd';
import moment from 'moment';
import {
    updateCheckedCondition,
    updateNumberCondition,
    visibleAppointmentConditions,
} from './appointmentStatusConditionHelpers';

function AppointmentServiceConditionChecklist({ item, onChangeItem, validationError }) {
    const conditions = useMemo(
        () => visibleAppointmentConditions(item?.condition_values || []),
        [item]
    );

    if (!conditions.length) return null;

    const changeCondition = (serviceConditionId, checked) => {
        const conditionValues = updateCheckedCondition(
            item.condition_values || [],
            serviceConditionId,
            checked,
            moment().format('YYYY-MM-DD')
        );

        onChangeItem('condition_values', conditionValues, item.id);
    };

    const changeNumberCondition = (serviceConditionId, value) => {
        const conditionValues = updateNumberCondition(
            item.condition_values || [],
            serviceConditionId,
            value
        );

        onChangeItem('condition_values', conditionValues, item.id);
    };

    return (
        <div style={{ marginTop: 12 }}>
            <div style={{ fontWeight: 600, marginBottom: 8 }}>
                Thông tin phục vụ tính hoa hồng
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px 20px' }}>
                {conditions.map(condition => condition.input_type === 'number' ? (
                    <div key={condition.service_condition_id} style={{ minWidth: 240 }}>
                        <div style={{ marginBottom: 6 }}>Số trụ đã cắm</div>
                        <InputNumber
                            min={condition.config?.min ?? 0}
                            max={condition.config?.max_source === 'customer_service.quantity'
                                ? Number(item.quantity) || 0
                                : condition.config?.max}
                            precision={0}
                            value={condition.value_number}
                            placeholder="Nhập số lượng đã cắm trụ"
                            style={{ width: '100%' }}
                            onChange={value => changeNumberCondition(
                                condition.service_condition_id,
                                value
                            )}
                        />
                        {validationError ? (
                            <div style={{ color: '#ff4d4f', marginTop: 4 }}>{validationError}</div>
                        ) : null}
                    </div>
                ) : (
                    <Checkbox
                        key={condition.service_condition_id}
                        checked={!!condition.is_satisfied}
                        onChange={event => changeCondition(
                            condition.service_condition_id,
                            event.target.checked
                        )}
                    >
                        {condition.name}
                    </Checkbox>
                ))}
            </div>
        </div>
    );
}

export default React.memo(AppointmentServiceConditionChecklist);
